import { render, staticRenderFns } from "./GameMode.vue?vue&type=template&id=d8f5566a"
import script from "./GameMode.vue?vue&type=script&lang=js"
export * from "./GameMode.vue?vue&type=script&lang=js"
import style0 from "./GameMode.vue?vue&type=style&index=0&id=d8f5566a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports